<template>
  <div class="ba-h-full" v-if="ready">
    <div class="ba-h-full">
      <vis-user-dashboard v-if="dashboard == 10"></vis-user-dashboard>
      <vis-operator-dashboard v-if="dashboard == 20"></vis-operator-dashboard>
      <vis-manager-dashboard v-if="dashboard == 30"></vis-manager-dashboard>
    </div>
  </div>
</template>

<script>
import VisUserDashboard from "@/views/base/dashboard/vis-user-dashboard";
import VisOperatorDashboard from "@/views/base/dashboard/vis-operator-dashboard";
import VisManagerDashboard from "@/views/base/dashboard/vis-manager-dashboard";
import rhmApi from "@/api/rhm-api";

export default {
  name: "vis-personal-dashboard-view",
  components: {VisUserDashboard, VisOperatorDashboard, VisManagerDashboard},
  data() {
    return {
      dashboard: null,
      ready: false,
    };
  },
  async created() {
    this.dashboard = (await rhmApi.staffing.getDashboard()) || 10;
    this.ready = true;
  },
};
</script>
